import React from "react";
import Stack from "../mui/Stack"; // assuming this is your custom wrapper around MUI Stack
import style from "../../utils/styled"; // your styled() utility
import { useTheme, useMediaQuery } from "@mui/material";
/**
 * BottomAction
 * A fixed bottom bar that stays visible while the rest of the page scrolls.
 * Ideal for mobile bottom buttons or actions.
 */
const BottomAction = ({ children, direction = "row", sx, ...restProps }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
    <StyledStack direction={direction} sx={sx} {...restProps}>
      {children}
    </StyledStack>
    </>
  );
};

const StyledStack = style(Stack)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1000, // Below modal (1300) but above drawer (1200) and content
  width: "100%",
  height: "100%",
  minHeight: "20px",
  backgroundColor: theme?.palette?.background?.paper,
  boxShadow: "0 -2px 6px rgba(0,0,0,0.15)",
  paddingTop: theme.spacing(1.5),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(1.5),
  boxSizing: "border-box",
  margin: 0,
  justifyContent: "center",
  alignItems: "center",

  // Desktop layout adjustment (if sidebar)
  [theme.breakpoints.up("sm")]: {
    left: "320px",
    right: "auto",
    width: "calc(100% - 342px)",
  },
}));


export default BottomAction;
